import * as React from 'react';
import * as w from '@packages/systems/wfdl';
import * as ast from '@packages/systems/wfdl-ast';
import * as q from '@packages/systems/wfdl-Qualified';
import {createDevlinkAtom} from '@packages/utilities/integrated-types';
import {cssifyName} from '@packages/systems/core/utils/TextUtils';
import {getChildren} from '@packages/utilities/data-utils';

const pathToName: w.ExpressionPath = [{in: 'Record', at: 'name'}];

const Slot = w.Atom.createRender(
  ({attributes, classes, generateAttributes, data, renderChild}) => {
    // @ts-expect-error - TS18046 - 'data' is of type 'unknown'
    const Tag = data.tag ?? 'div';
    // @ts-expect-error - TS18046 - 'data' is of type 'unknown'
    const slot = data.slot ?? null;
    return (
      <Tag
        {...generateAttributes(attributes, classes)}
        {...(slot ? {slot} : {})}
      >
        {getChildren(data).map((child) => renderChild(child))}
      </Tag>
    );
  }
);

const config = createDevlinkAtom({
  displayName: {
    type: 'Derived',
    defaultValue: 'Slot',
    getFromElement: (el) => {
      const nameExpr = w.Expressions.getIn(el.data, pathToName);
      const name = nameExpr ? w.Expressions.getText(nameExpr) : null;
      // If there is no displayName or displayName is not css-ify-able, use 'Slot'
      return name && cssifyName(name) ? name : 'Slot';
    },
  },
  icon: {
    type: 'Component',
    value: [w.Plugins.name('Slots'), q.iconName('Slot')],
  },
  fields: {
    children: w.withSystem(
      {private: true, isBindable: true},
      ast.TList(ast.TElement)
    ),
    name: w.withSystem(
      {label: 'Name', isBindable: false, private: true},
      ast.TText
    ),
    tag: w.withSystem(
      {
        label: 'Tag',
        private: true,
        defaultValue: 'div',
        isLocalizable: true,
      },
      ast.TTypeConstructor(
        q.qualify(q.pluginName('Basic'), q.typeName('TagsDropdown'))
      )
    ),
    slot: w.withSystem(
      {label: 'Slot', isBindable: false, private: true, defaultValue: ''},
      ast.TText
    ),
    // Component ids ("__SitePlugin::<name>") a component author has restricted
    // this Slot to. An empty list means the Slot is unrestricted, and is also
    // what reification seeds onto a Slot stored before this field was declared
    // -- see the note on `allowedComponentsPath` in
    // packages/systems/component-slots/SlotElementUtils.ts.
    allowedComponents: w.withSystem(
      {isBindable: false, private: true, defaultValue: []},
      ast.TList(ast.TText)
    ),
  },
  showEmpty: true,
  render: Slot,
});

export default config;
